import { BackupItem, BackupConfig, RestoreOptions } from './types';

export class BackupAPI {
  static async fetchBackups(): Promise<BackupItem[]> {
    try {
      const response = await fetch('/api/backups');
      if (response.ok) {
        const data = await response.json();
        return Array.isArray(data) ? data : data.backups || [];
      }
      throw new Error(`Failed to fetch backups: ${response.statusText}`);
    } catch (error) {
      console.error('Failed to fetch backups:', error);
      throw error;
    }
  }

  static async fetchBackupConfig(): Promise<BackupConfig> {
    try {
      const response = await fetch('/api/backups/config');
      if (response.ok) {
        const data = await response.json();
        return data;
      }
      throw new Error(`Failed to fetch backup config: ${response.statusText}`);
    } catch (error) {
      console.error('Failed to fetch backup config:', error);
      throw error;
    }
  }

  static async saveBackupConfig(config: BackupConfig): Promise<void> {
    try {
      const response = await fetch('/api/backups/config', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(config),
      });

      if (!response.ok) {
        throw new Error(`Failed to save backup config: ${response.statusText}`);
      }
    } catch (error) {
      console.error('Failed to save backup config:', error);
      throw error;
    }
  }

  static async createBackup(zoneId?: string): Promise<any> {
    try {
      const response = await fetch('/api/backups', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ zoneId, operation: 'manual' }),
      });
      if (!response.ok && response.status !== 202 && response.status !== 201) {
        throw new Error(`Failed to create backup: ${response.statusText}`);
      }
      const data = await response.json().catch(() => ({}));
      return data;
    } catch (error) {
      console.error('Failed to create backup:', error);
      throw error;
    }
  }

  static async restoreBackup(backupId: string, options: RestoreOptions): Promise<void> {
    try {
      const response = await fetch(`/api/backups/${backupId}/restore`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(options),
      });

      if (!response.ok) {
        throw new Error(`Failed to restore backup: ${response.statusText}`);
      }
    } catch (error) {
      console.error('Failed to restore backup:', error);
      throw error;
    }
  }

  static async downloadBackup(backupId: string): Promise<Blob> {
    try {
      const response = await fetch(`/api/backups/${backupId}/download`);
      if (response.ok) {
        return await response.blob();
      }
      throw new Error(`Failed to download backup: ${response.statusText}`);
    } catch (error) {
      console.error('Failed to download backup:', error);
      throw error;
    }
  }

  static async deleteBackup(backupId: string): Promise<void> {
    try {
      const response = await fetch(`/api/backups/${backupId}`, {
        method: 'DELETE',
      });

      if (!response.ok) {
        throw new Error(`Failed to delete backup: ${response.statusText}`);
      }
    } catch (error) {
      console.error('Failed to delete backup:', error);
      throw error;
    }
  }
}
